import {setupLayouts} from 'virtual:generated-layouts'
import {createRouter, createWebHistory} from 'vue-router'
import routes from '~pages'
import axios from "@axios"

import {useAbility} from '@casl/vue'
import {useMemberStore} from "../store/memberStore.js";

const router = createRouter({
    history: createWebHistory(),
    routes: [
        ...setupLayouts(routes),
    ],
})

// Docs: https://router.vuejs.org/guide/advanced/navigation-guards.html#global-before-guards
router.beforeEach((to, from, next) => {
    const userData = JSON.parse(localStorage.getItem('userData') || '{}')
    const userRole = userData && userData.role ? userData.role : null
    const memberStore = useMemberStore()

    if (!to.path.startsWith("/admin")) {
        axios.post(`analytics`, {
            ...to
        })
    }

    if (to.path.startsWith("/member/forum") && !memberStore.userData.isActiveMember) {
        next('/member/inactive')
        return
    }

    if (userRole && userRole === 'admin') {
        next()
        return
    }
    if (userRole && userRole === 'customer') {
        next()
        return
    }

    const {can} = useAbility()

    if (to.meta.subject && !can(to.meta.action || 'list', to.meta.subject)) {
        next('/forbidden')
        return
    }

    next()
    // const isLoggedIn = isUserLoggedIn()
    // const userData = JSON.parse(localStorage.getItem('userData') || '{}')
    // const userRole = userData && userData.role ? userData.role : null
    // if (canNavigate(to) || (userRole === 'user' && to.path.includes('events'))) {
    //     if (to.meta.redirectIfLoggedIn && isLoggedIn) next('/')
    //     else next()
    // } else {
    //     if (isLoggedIn) {
    //         next({name: 'not-authorized'})
    //     } else {
    //         next({name: 'login', query: {to: to.name !== 'index' ? to.fullPath : undefined}})
    //     }
    // }
})

export default router
